export default "__VITE_ASSET__C0L69jE7__"